<template>
    <div class="gird" :style="{ 'height': height }" ref="gird" @scroll="leftEvent">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "ItemGrid",
        props: {
            height: {
                required: false,
                type: String,
                default: 'auto'
            },
        },
        data() {
            return {
                //左滑紀錄位置
                scrollLeft: 0
            }
        },
        created() {

        },
        mounted() {

        },
        activated() {
            this.$refs.gird.scrollLeft = this.scrollLeft;
        },
        methods: {
            leftEvent() {
                this.scrollLeft = this.$refs.gird.scrollLeft;
            },
        }
    }
</script>

<style lang="less" scoped>

</style>